module.exports = __webpack_public_path__ + "img/bg4.9cbccb00.png";